import "es6-shim";
import * as React from 'react';
import { Popup } from './genericComponents/Popup';
const failImage = require('../assets/images/fail-error.png');

interface ErrorPopupProps {
    show: boolean;
    text: { title: string, closeButton: string, errorMessage: React.ReactNode },
    children: React.ReactNode,
    onClose(): void;
}

/**
 * @export
 * @class ErrorPopup
 * @extends {React.Component<ErrorPopupProps, any>}
 */
export const ErrorPopup = (props: ErrorPopupProps) => {
    return (
        <div>
            <Popup
                visible={props.show}
                hidepopup={() => { props.onClose() }}
                title={props.text.title ? props.text.title : "Error Encountered"}
                message={props.text.errorMessage}
                closeButtonText={props.text.closeButton}
            >
                <img src={failImage} style={{ width: "75px" }} />
                {props.children}
            </Popup>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/ErrorPopup.tsx